<template>
  <div class="container-fluid">
    <User-Menu v-on:executeStop="onExecuteCancel" v-on:executeStart="onExecuteStart" />
    <Navbar-FeedCategories v-if="this.showContent" :categories="categories" routeName="user" />
    <Content-Static v-if="this.showContent" :feeds="this.$store.state.UserFeeds" routeName="user"/>
    <navbar-dynamic-bars v-if="this.showContent" :feeds="this.$store.state.UserFeeds" routeName="userWithPage"/>
  </div>
</template>

<script>
// @ is an alias to /src
import UserMenu from '@/components/User/User.Menu.vue'
import NavbarFeedCategories from '@/components/Navbars/Navbar.FeedCategories.vue'
import ContentStatic from '@/components/ContentStatic.vue'
import NavbarDynamicBars from '@/components/Navbars/NavbarDynamicBars.vue'

import { mapActions } from 'vuex'

export default {
  name: 'home',
  components: {
    NavbarFeedCategories,
    NavbarDynamicBars,
    ContentStatic,
    UserMenu,
  },
  data: function() {
    return {
      showContent: true
    };
  },
  computed: {
    categories() {
      return this.$store.state.UserFeeds.items;
    },
  },
  methods: {
    ...mapActions([
      'loadUserFeeds',
    ]),
    onExecuteCancel: function() {
      this.showContent = true;
    },
    onExecuteStart: function() {
      this.showContent = false;
    },
  },
  created () {
    this.loadUserFeeds()
  },
}
</script>
